import React, {Component} from 'react';
const { connect } = require('react-redux');
import MasonryLayout from 'react-masonry-layout';

import {getProfileGuestbook} from 'reducers/profileGuestbook';

import {t, dt} from 'l10n';

import 'sass/profile/ProfileIndex.scss';
import 'sass/profile/guestbook.scss';

import HeaderBrief from '../../components/profile/HeaderBrief';
import GuestbookItem from '../../components/guestbook/GuestbookItem';
import ModalAddGuestbookMessage from '../../components/modals/ModalAddGuestbookMessage';
import Loading from 'components/Loading';
import NotFound from 'containers/NotFound';

import {getReturnPath} from 'utils/url';
import {Helmet} from "react-helmet";
import {formatMetaLocation} from "../../utils/user";


class ProfileGuestbook extends Component{
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            profileGuestbook: props.profileGuestbook,
        }
    }

    static fetchData({dispatch, match}) {
        let {nick} = match.params;

        return dispatch(getProfileGuestbook(nick));
    }

    componentDidMount() {
        let {dispatch, match, profileGuestbook} = this.props;

        if (!profileGuestbook.user || match.params.nick !== profileGuestbook.user.nick) {
            this.constructor.fetchData({dispatch, match});
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextProps.profileGuestbook.guestbookMessages.totalCount > this.props.profileGuestbook.guestbookMessages.totalCount) {
            let {dispatch, match} = nextProps;
            this.constructor.fetchData({dispatch, match});
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.profileGuestbook.guestbookMessages.totalCount != this.props.profileGuestbook.guestbookMessages.totalCount) {

            if(this.masonryLayout.instanceElement) {
                this.masonryLayout.getBricksInstance().pack();
            }
        }
    }

    render() {
        let {match, profileGuestbook, currentUser, dispatch} = this.props,
            {user, blacklistedMe, online, guestbookMessages} = profileGuestbook,
            {isLoading, list, totalCount, offset} = guestbookMessages;

        const {showModal} = this.state;

        const sizes = [
            { mq: '320px', columns: 1, gutter: 10 },
            { mq: '480px', columns: 2, gutter: 10 },
            { mq: '600px', columns: 2, gutter: 10 },
            { mq: '980px', columns: 3, gutter: 20 },
            { mq: '1450px', columns: 4, gutter: 40 },
        ];

        if (!user) {
            return <Loading centered/>;
        }

        if (user._notFound) {
            return <NotFound {...this.props}/>
        }

        return (
            <div id="wrapper">
                {user &&
                    <Helmet>
                        <title>{dt('meta', 'Le livre d’or de %1 amateur en cam sur BobTV', user.nick)}</title>
                        <meta name="description" content={dt('meta', 'Encouragez %1 (%2) qui participe aux discussions de cul et aux Shows Sexy sur les salles de Visio Chat', user.nick, formatMetaLocation(user))}/>
                    </Helmet>
                }
                <ModalAddGuestbookMessage
                    show={showModal}
                    closeFn={() => this.setState({showModal: false})}
                    currentUser={currentUser}
                    user={user}
                    blacklistedMe={blacklistedMe}
                    returnPath={getReturnPath({match})}
                />
                <HeaderBrief user={user} online={online} match={match}/>
                <aside className="profile-guestbook">
                    <div className="content">
                        <div className="heading">
                            <h2>{t('Guestbook')} <em>{totalCount}</em></h2>
                            <a className="add-item" onClick={() => this.setState({showModal: true})}>{t('Add a comment')}</a>
                        </div>
                        <div className="list-questbook">
                            <MasonryLayout
                                infiniteScroll={() => dispatch(getProfileGuestbook(user.nick, offset))}
                                infiniteScrollLoading={isLoading}
                                infiniteScrollEnd={offset >= totalCount}
                                infiniteScrollEndIndicator={null}
                                infiniteScrollSpinner={null}
                                sizes={sizes}
                                id="profile-guestbook"
                                ref={instance => this.masonryLayout = instance}
                            >
                                {list.map((item) => <GuestbookItem key={item.id} guestbookMessage={item}/>)}
                            </MasonryLayout>
                        </div>
                    </div>
                </aside>
            </div>
        )
    }
}

export default connect(
    state => ({
        profileGuestbook: state.profileGuestbook,
        currentUser: state.currentUser
    }),
    null
)(ProfileGuestbook)


// WEBPACK FOOTER //
// ./src/containers/profile/ProfileGuestbook.js